import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './NoResults.module.scss';

export const NoResults = () => {
  const { t } = useTranslation('widget');

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <img
          className={styles.image}
          data-testid="empty-assets-img"
          src="/app/static/images/empty-state/no-search-result.svg"
          alt=""
        />
        <span className={styles.text}>
          {t('widget:search.noSearchResults')}
        </span>
      </div>
    </div>
  );
};

